import { Button } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

function Footer() {
    const location = useLocation();
  return (
      <footer className="my-4 text-center text-muted small">
          {location.pathname !== "" && 
              location.pathname !== "/" && 
              location.pathname !== "/idproofing" && 
              location.pathname !== "/idproofing/" &&
              <div>
                  <Button className="home-button" href={`/idproofing/`} >Home</Button>
              </div>
          }
          &copy; {new Date().getFullYear()} toppansecurity.com | All Rights Reserved  
    </footer>
  );
}

export default Footer;
